module.exports = __webpack_public_path__ + "static/media/image.43ab68ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/greeting/image.png
// module id = 616
// module chunks = 0